import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'mapbox-gl/dist/mapbox-gl.css';
import theme from './styling/theme';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</LocalizationProvider>
		</ThemeProvider>
	</React.StrictMode>
);
